import { lazy } from 'react';
import { isPublicSitePageEnabled } from '@/publicSite/publicSiteConfig';
import type { AppRouteDefinition } from './routes';

const DocsPage = lazy(async () => {
  const module = await import('../../pages/DocsPage');
  return { default: module.DocsPage };
});

const AppFeaturesPage = lazy(async () => {
  const module = await import('@/features/features/routes');
  return { default: module.FeaturesPage };
});

const PublicFeaturesPage = lazy(async () => {
  const module = await import('../../pages/FeaturesPage');
  return { default: module.FeaturesPage };
});

const PricingPage = lazy(async () => {
  const module = await import('../../pages/PricingPage');
  return { default: module.PricingPage };
});

export const publicSiteRouteDefinitions: AppRouteDefinition[] = [
  {
    key: 'docs',
    path: '/docs',
    enabled: isPublicSitePageEnabled('docs'),
    title: 'Docs',
    element: () => <DocsPage />,
  },
  {
    key: 'public-features',
    path: '/features',
    enabled: isPublicSitePageEnabled('features'),
    title: 'Features',
    description:
      'Review FlowQA features for test reporting, suite history, pass rate trends, recurring failures, filtering, and QA analytics.',
    element: ({ session }) => (session ? <AppFeaturesPage /> : <PublicFeaturesPage />),
  },
  {
    key: 'pricing',
    path: '/pricing',
    enabled: isPublicSitePageEnabled('pricing'),
    title: 'Pricing',
    description:
      'View FlowQA pricing for Trial, Solo, and Team plans. Compare projects, users, monthly runs, and retention.',
    element: () => <PricingPage />,
  },
];
